<template>
  <div>
    <div class="Fuell-Toolbar">
      <ul class="Fuell-Tabs">
        <li
          class="Fuell-Tabs--tab"
          v-if="hasFlexRetActivated"
        >
          <router-link
            to="/benefits/users"
            class="Fuell-Tabs--link"
            active-class="active"
            v-t="{ path: 'benefits_tab_flex_retribution' }"
          ></router-link>
        </li>
        <li
          class="Fuell-Tabs--tab"
          v-if="hasSubventionsActivated"
        >
          <router-link
            to="/benefits/social-benefits"
            class="Fuell-Tabs--link"
            active-class="active"
            v-t="{ path: 'benefits_tab_social_benefits' }"
          ></router-link>
        </li>

        <li class="Fuell-Tabs--tab">
          <router-link
            to="/benefits/transactions"
            class="Fuell-Tabs--link"
            active-class="active"
            v-t="{ path: 'benefits_tab_flex_transactions' }"
          ></router-link>
        </li>
      </ul>
      <div class="ml-auto"></div>

      <button
        class="Fuell-ToolbarButton blue"
        @click="showBenefitsConfigurationModal"
        v-if="isCheckingUserBenefits"
      >
        <span
          class="Fuell-ToolbarButton--label"
          v-t="{ path: 'benefits_configuration' }"
        ></span>
      </button>
      <button
        class="Fuell-ToolbarButton blue ml-3"
        @click="showBenefitsExportModal"
      >
        <span
          class="Fuell-ToolbarButton--label"
          v-t="{ path: exportRenderLabel }"
        >
        </span>
      </button>
    </div>

    <benefits-export-modal
      :open.sync="showBenefitsExportModalFlag"
      v-if="showBenefitsExportModalFlag"
    >
    </benefits-export-modal>
    <benefits-configuration-modal
      :open.sync="showBenefitsConfigurationModalFlag"
      @showConfirmModal="showConfirmModal"
      @showTimeRestrictionsModal="showTimeRestrictionsModal"
      v-if="showBenefitsConfigurationModalFlag"
    >
    </benefits-configuration-modal>
    <confirm-modal
      v-if="showConfirmModalFlag"
      :open.sync="showConfirmModalFlag"
      :dismissText="'ACTION_CANCEL'"
      :title="'benefits_confirm_acumulation_removal_action_confirm'"
      :acceptText="'benefits_confirm_acumulation_removal_action_confirm'"
      :message="'benefits_confirm_acumulation_setting_removal_office_warning'"
      @accept="toggleAccumulativeStatus"
    >
    </confirm-modal>
    <benefits-time-restrictions-configuration-modal
      :open.sync="showBenefitsTimeRestrictionsConfigurationModalFlag"
      v-if="showBenefitsTimeRestrictionsConfigurationModalFlag"
    ></benefits-time-restrictions-configuration-modal>
    <router-view></router-view>
  </div>
</template>

<script>
import _userOfficeBenefitsConfigurationHandler from '../_mixins/_userOfficeBenefitsConfigurationHandler'
const BenefitsConfigurationModal = () => import('../_components/users/BenefitsConfigurationModal')
const BenefitsTimeRestrictionsConfigurationModal = () => import('../_components/users/BenefitsTimeRestrictionsConfigurationModal')
const BenefitsExportModal = () => import('../_components/transactions/BenefitsExportModal.vue')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
export default {
  name: 'BenefitsIndex',
  data () {
    return {
      showBenefitsExportModalFlag: false,
      showBenefitsConfigurationModalFlag: false,
      showConfirmModalFlag: false,
      showBenefitsTimeRestrictionsConfigurationModalFlag: false
    }
  },
  mixins: [_userOfficeBenefitsConfigurationHandler],
  components: {
    BenefitsExportModal,
    BenefitsConfigurationModal,
    BenefitsTimeRestrictionsConfigurationModal,
    ConfirmModal
  },
  computed: {
    exportRenderLabel () {
      return this.isExporting ? 'ACTION_EXPORT_IN_PROGRESS' : 'benefits_export'
    },
    isCheckingUserBenefits () {
      return this.$route.name === 'benefits_users'
    },
    hasSubventionsActivated () {
      const hasSubventions = this.currentCompany.activatedFeatures.find(el => el.feature.code === 'SUBVENTION_FEATURE')
      return !!hasSubventions
    },
    hasFlexRetActivated () {
      const hasRetFlex = this.currentCompany.activatedFeatures.find(el => el.feature.code === 'FLEXIBLE_REMUNERATION')
      return !!hasRetFlex
    },
    currentCompany () {
      return this.$store.getters['CompanyStore/currentCompany'] || false
    },
    currentOfficeExtraFeatures () {
      return (
        this.$store.getters['CompanyStore/currentCompany'].activatedFeatures &&
        this.$store.getters['CompanyStore/currentCompany'].activatedFeatures.length > 0
      )
    }
  },
  methods: {
    showBenefitsExportModal () {
      this.showBenefitsExportModalFlag = true
    },

    showBenefitsConfigurationModal () {
      this.showBenefitsConfigurationModalFlag = true
    },
    showTimeRestrictionsModal () {
      this.showBenefitsTimeRestrictionsConfigurationModalFlag = true
    },
    validateOfficeFeatureIsActive () {
      if (!this.currentOfficeExtraFeatures) {
        this.$router.push({ name: 'dashboard' })
        this.$store.dispatch(
          'SnackBars/addError',
          this.$t('office_feature_not_available'),
          { root: true }
        )
      }
    },
    showConfirmModal () {
      this.showConfirmModalFlag = true
    }
  },
  created () {
    this.$store.dispatch('CompanyStore/fetchCompany', this.officeId)
  }
}
</script>
<style scoped>
@media screen and (max-width: 576px) {
  .Fuell-ToolbarButton {
    margin: 10px 0px;
    width: 100%;
  }
  .Fuell-ToolbarButton:last-of-type {
    margin-left: 0px !important;
  }
  .Fuell-ToolbarButton--label {
    width: 100%;
    text-align: center;
  }
}
</style>
